var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.userEvents,
      expression: "loading.userEvents"
    }],
    attrs: {
      "title": _vm.title
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Filter by Event name..."
    },
    model: {
      value: _vm.query,
      callback: function ($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }, _vm._l(_vm.events, function (event) {
    return _c('el-option', {
      key: event,
      attrs: {
        "value": event,
        "label": event
      }
    });
  }), 1), _c('Table', {
    attrs: {
      "items": _vm.userEvents.results,
      "columns": _vm.columns,
      "actions": _vm.actions
    }
  }), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "current-page": _vm.userEvents.page + 1,
      "total": _vm.userEvents.total
    },
    on: {
      "current-change": _vm.fetchData
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }